import React, { useEffect, useState } from 'react'
import { ThirdSectionCss } from './Dashboard.style';
function ThirdSection(props) {
    const { Validatelogin, customerCheck } = props;

    return (
        <>
            <ThirdSectionCss>

                <div className='container third-section'>
                    <div className='first-section'>
                        <h1>TERMS & REQUIREMENTS</h1>
                        <div className='referral-urls'>
                            <h4>Affiliate URL Code to give to Customers:</h4>
                            <p>As an Affiliate, your account is automatically assigned a unique URL code, such as: <a href='cc1234.shopkaire.com'>cc1234.shopkaire.com</a>
                                &nbsp;If you’d like, you can customize this URL in your account settings to make it more personal such as <a href='yourname.shopkaire.com'>yourname.shopkaire.com</a>&nbsp;to ensure your customer is automatically linked to your account, simply share your unique URL with them.</p>
                            <h4>Commissions:</h4>
                            <p>
                                As a Kaire affiliate, you'll earn a generous 20% commission on the first order of every customer you refer and 10% commission on any further orders that customer purchases! *
                            </p>
                            <p>Any Commissions earned are paid on the 15th of the following calendar month.</p>
                            <p>As an  Affiliate, your customer must place an order using the unique referral code for you to receive Commissions.</p>
                            <h4>Requirements:</h4>
                            <p>A Customer’s address must be from a different household than the Affiliate.
                            </p>
                        </div>
                    </div>

                    <div className='images-section'>
                        <img src='/images/thirdsection-image.png' />
                    </div>
                </div>
            </ThirdSectionCss>


        </>
    )
}
export default ThirdSection;
